const configuredBackendUrl = process.env.REACT_APP_BACKEND_URL?.trim();

export const BACKEND_URL = (
  configuredBackendUrl || "https://smartmattressalex.com"
).replace(/\/+$/, "");